module.exports = __webpack_public_path__ + "img/150h100_s_odnoy_povorotno_otkidnoy_polovinoy.a773421d.svg";